import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../../api";

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() && isAuthenticated().user.role === "admin" ? (
        <Component {...props} />
      ) : (
        <Redirect to="/error/403" />
      )
    }
  />
);

export default AdminRoute;
